// src/assets/oracle/deck/index.js
let cards = { en: {}, es: {}};

const cardCount = 89;

for (let i = 1; i <= cardCount; i++) {
   
  cards[i] = cards.en[i] = require(`./en/${i}.png`);
}

for (let i = 1; i <= cardCount; i++) {
  cards.es[i] = require(`./es/${i}.png`);
}

export const getRandomCardImage = (lang) => {
  const randomId = Math.floor(Math.random() * 89) + 1;
  
  return lang && cards[lang] ? cards[lang][randomId] : cards[randomId]; // Retorna la ruta local (ej: /static/media/1.png)
};

export default cards;